import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '../lib/api';

const ThemeContext = createContext(null);
export const useTheme = () => useContext(ThemeContext);

export const TEMAER = [
  { id: 'regnino', navn: 'Regnino (nordisk lys)', preview: '#fafbfc' },
  { id: 'default', navn: 'Mørk blå',              preview: '#22273a' },
  { id: 'modern',  navn: 'Modern (slate)',        preview: '#0f172a' },
  { id: 'primary', navn: 'Primary (cyber)',       preview: '#0a0a0f' },
  { id: 'light',   navn: 'Light (lys)',           preview: '#f8f9fa' },
];

export const ThemeProvider = ({ children }) => {
  const [tema, setTemaState] = useState(() => localStorage.getItem('tema') || 'regnino');

  useEffect(() => {
    document.documentElement.setAttribute('data-template', tema);
    localStorage.setItem('tema', tema);
  }, [tema]);

  // Lytt etter ekstern temaendring (f.eks. fra AuthContext etter login)
  useEffect(() => {
    const sync = () => {
      const t = localStorage.getItem('tema') || 'regnino';
      setTemaState((prev) => (prev !== t ? t : prev));
    };
    window.addEventListener('storage', sync);
    window.addEventListener('tema-endret', sync);
    return () => {
      window.removeEventListener('storage', sync);
      window.removeEventListener('tema-endret', sync);
    };
  }, []);

  const setTema = useCallback(async (nytt) => {
    setTemaState(nytt);
    try {
      if (localStorage.getItem('token')) {
        await api.put('/firma', { tema: nytt });
      }
    } catch { /* tema lagres lokalt uansett */ }
  }, []);

  return (
    <ThemeContext.Provider value={{ tema, setTema, temaer: TEMAER }}>
      {children}
    </ThemeContext.Provider>
  );
};
